style= require('./api-browser.styl')
- const competitions = require('./competitions.jade')
- const competition = require('./competition.jade')
- const fixture = require('./fixture.jade')
- const liveFeed = require('./live-feed.jade')

ft-tabs
  each sport in sports
    ft-tab(
      active=this.sport === sport,
      (click)=this.setSport(sport)
    )= sport

if sport
  ft-tabs
    each tab in tabs
      ft-tab(
        active=this.tab === tab,
        (click)=this.setTab(tab)
      )= tab

  section
    if tab === 'competitions'
      +competitions(parent=this)
    if tab === 'competition'
      +competition(parent=this)
    if tab === 'fixture'
      +fixture(
        parent=this,
        fixture=this.data[this.api].fixture.fixture,
        columns=this.data[this.api].fixture.columns
      )
    if tab === 'liveFeed'
      +liveFeed(parent=this)
